import { useEffect, useRef, useState } from "react";
import { PleasewaitPopup } from "./PleasewaitPopup";
import useAuth from "../hook/useAuth";
import axios from "../config/axios";
import baseURL from "../config/api";
import { post_SubLessonfileUpload } from "../services/FileUpload";

type AddImageFileProps = {
    showPopup: boolean;
    setShowPopup: (value: boolean) => void;
    setRefreshImageFileList: (value: boolean) => void;
    subLessonId: number;
}

export const AddImageFile = ({ showPopup, setShowPopup, setRefreshImageFileList, subLessonId }: AddImageFileProps) => {
    const { auth }: any = useAuth();
    const inputFileRef = useRef<HTMLInputElement>(null);
    const [uploadFileImg, setUploadFileImg] = useState<FileList | null>(null);
    const [showPleasewait, setShowPleasewait] = useState<boolean>(false);

    useEffect(() => {
        if (showPopup) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => {
            document.body.classList.remove("overflow-hidden");
        };
    }, [showPopup]);

    if (!showPopup) return null;

    const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFiles = e.target.files as FileList;
        if (selectedFiles.length !== 0) {
            setUploadFileImg(selectedFiles);
        }
    };

    const handleOnSave = async () => {
        if (uploadFileImg && uploadFileImg?.length > 0) {
            setShowPleasewait(true);
            const formData = new FormData();
            formData.append("ImageFile", uploadFileImg[0]);
            try {
                const uploadRes = await axios.post(`${baseURL}commonFile/Upload`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                    withCredentials: false,
                });

                let uploadedImagePath = uploadRes?.data;
                saveFilePath(uploadedImagePath);
            } catch (err) {
                console.error("Image upload failed:", err);
            }
        }
    }

    const saveFilePath = (imagePath: string) => {
        post_SubLessonfileUpload({
            attributeName: "SubLessonFile",
            attributeId: subLessonId,
            fileName: imagePath,
            tabName: "SubLesson",
            userId: auth?.id,
            createdDate: new Date().toISOString()
        })
            .then((res) => {
                setShowPleasewait(false);
                setShowPopup(false);
                setRefreshImageFileList(true);
            })
            .catch((error) => {
                console.error(error)
            })
    }

    return (
        <>
            <div className="fixed inset-0 z-[9999999] flex items-center justify-center bg-black/50 p-10">
                <div className="bg-white w-full max-w-xl rounded-md shadow-lg max-h-[90vh] flex flex-col overflow-auto">

                    <div className="px-6 py-4 border-b w-full flex justify-between items-center">
                        <h2 className="text-lg font-medium">Upload Image</h2>
                        <button
                            onClick={() => {
                                setShowPopup(false)
                            }}
                            className="text-gray-500"
                        >
                            <span className="material-symbols-outlined text-2xl">
                                close
                            </span>
                        </button>
                    </div>


                    <div>
                        <div className="px-6 py-6">
                            <input
                                name="image"
                                type="file"
                                accept="image/*"
                                className="block w-full rounded border border-gray-300 px-3 py-2 shadow-sm outline-none text-sm placeholder:text-gray-400 focus:ring-2 focus:ring-[#167AC3] focus:ring-offset-1 mt-1 bg-transparent"
                                onChangeCapture={onFileChangeCapture}
                                ref={inputFileRef}
                            />
                        </div>


                    </div>

                    <div className="px-6 py-4 border-t flex justify-end space-x-3">

                        <button
                            className={`px-6 py-2 ${!uploadFileImg || !inputFileRef.current?.value ? "bg-gray-300 text-white cursor-not-allowed" : "bg-primary text-white cursor-pointer"}  font-medium rounded`}
                            disabled={!uploadFileImg || !inputFileRef.current?.value ? true : false}
                            onClick={handleOnSave}
                        >
                            Upload
                        </button>
                    </div>
                </div>
            </div >
            <PleasewaitPopup showPopup={showPleasewait} />
        </>
    )
}